import { render } from "./Item.vue?vue&type=template&id=5e3aca60"
import script from "./Item.vue?vue&type=script&lang=js"
export * from "./Item.vue?vue&type=script&lang=js"

import "./Item.vue?vue&type=style&index=0&id=5e3aca60&lang=scss"
script.render = render

export default script